import { useEffect, useRef, useState } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import "./TutorialStyles.scss";
import { update_tutorial_progress } from "../../network/communication";

function QuizzyPlusTutorial(props) {
  const user = props.user;
  const membership = user?.membership;
  const stepIndex = props.stepIndex;
  const setStepIndex = props.setStepIndex;

  const tutorialPhase = props.phase;
  const setTutorialPhase = props.setPhase;

  // Inside your component
  const tutorialPhaseRef = useRef(tutorialPhase);
  const stepIndexRef = useRef(stepIndex);

  const isStudyPage =
    window.location.pathname.indexOf("/study") !== -1 &&
    /^\/study\/\d+\/[\w\-!]+\/?$/.test(window.location.pathname);

  const isQuizPage =
    window.location.pathname.indexOf("/quiz") !== -1 &&
    /\/quiz\/[\w\d]+\/results$/.test(window.location.pathname);

  const isDashboardPage =
    window.location.pathname.indexOf("/dashboard") !== -1 &&
    /^\/dashboard/.test(window.location.pathname);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    }
  };

  const phase0Step = [
    {
      target: ".imgDiv",
      title: "Your Supercharged File Size!",
      placement: "left",
      disableBeacon: true,
      content:
        "With your new Quizzy+ subscription, you can now upload bigger images and clips to your avatar, as well to as every flashcard you create.",
    },
  ];

  const phase1Step = [
    {
      target: ".your-studying",
      title: "You've unlocked Learning Faster!",
      placement: "bottom",
      disableBeacon: true,
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/fasterLearning.png"
            alt="learn faster"
            style={{ width: "100%" }}
          ></img>
          <p>
            Ready to learn faster than your friends? With your new Quizzy+
            subscription, you can adjust your learning pace for all of the sets
            you study.
          </p>
        </>
      ),
    },
  ];

  const phase2Step = [
    {
      target: ".other-quizzes",
      title: "You've unlocked more Past Quizzes!",
      placement: "left",
      disableBeacon: true,
      content: (
        <>
          <p>
            Nice job with your studying! With your new Quizzy+ subscription, you
            can view more of your Past Quizzes for all of your Study Sets.
          </p>
        </>
      ),
    },
  ];

  // End of basic features

  // Start of Quizzy+ Premium features

  const phase3Step = [
    {
      target: ".most-difficult-terms-title",
      title: "Your new Most Difficult Terms",
      placement: "bottom",
      disableBeacon: true,
      content: (
        <>
          <p>
            With your new Quizzy+ Premium subscription, Quizzy+ will
            automatically pick up on your most difficult terms as you study and
            show you them here.
          </p>
        </>
      ),
    },
    {
      target: "body",
      title: "The Most Difficult Term Icon",
      placement: "center",
      disableBeacon: true,
      content: (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="37"
            height="37"
            viewBox="0 0 37 37"
            className="most-difficult-term-mark"
          >
            <g
              id="Group_2070"
              data-name="Group 2070"
              transform="translate(-679 -397)"
            >
              <circle
                id="Ellipse_489"
                data-name="Ellipse 489"
                cx="18.5"
                cy="18.5"
                r="18.5"
                transform="translate(679 397)"
                fill="#8358e8"
              />
              <path
                id="sentiment_stressed_FILL0_wght400_GRAD0_opsz48"
                d="M86.482,188.607l4.252-3.092-4.252-3.092-1.07,1.427,2.29,1.665-2.29,1.665Zm10.823,0,1.07-1.427-2.29-1.665,2.29-1.665-1.07-1.427-4.252,3.092Zm-7.2,5.293,1.784-1.784,1.784,1.784,1.784-1.784,1.16,1.16,1.249-1.249-2.408-2.408L93.678,191.4l-1.784-1.784L90.109,191.4l-1.784-1.784-2.408,2.408,1.249,1.249,1.16-1.16Zm1.784,5.887a11.581,11.581,0,0,1-4.638-.937,11.875,11.875,0,0,1-6.318-6.318,11.954,11.954,0,0,1,0-9.277,11.875,11.875,0,0,1,6.318-6.318,11.954,11.954,0,0,1,9.277,0,11.875,11.875,0,0,1,6.318,6.318,11.954,11.954,0,0,1,0,9.277,11.875,11.875,0,0,1-6.318,6.318A11.582,11.582,0,0,1,91.894,199.787ZM91.894,187.893Zm0,10.109a10.032,10.032,0,1,0-7.171-2.938A9.757,9.757,0,0,0,91.894,198Z"
                transform="translate(605.607 227.606)"
                fill="#fff"
              />
            </g>
          </svg>
          <p>
            As you study, look for this icon, it'll be near terms you're
            struggling with.
          </p>
        </>
      ),
    },
  ];

  const phase4Step = [
    {
      target: ".add-task-btn-dashboard",
      title: "Adding Tasks",
      placement: "bottom",
      disableBeacon: true,
      content: (
        <>
          <p>
            With your new Quizzy+ Premium subscription, you can add your own
            tasks to your schedule. The best part? You can choose exactly which
            terms you want to study.
          </p>
        </>
      ),
    },
  ];

  // Update refs whenever the values change
  useEffect(() => {
    tutorialPhaseRef.current = tutorialPhase;
    stepIndexRef.current = stepIndex;
    update_tutorial_progress(
      "quizzyplus",
      tutorialPhaseRef.current,
      stepIndexRef.current
    );
  }, [tutorialPhase, stepIndex]);

  return (
    <>
      {tutorialPhase === 0 && isDashboardPage && (
        <Joyride
          steps={phase0Step}
          scrollToFirstStep
          hideBackButton
          stepIndex={stepIndex}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          callback={handleJoyrideCallback}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}

      {isStudyPage && tutorialPhase === 1 && (
        <Joyride
          steps={phase1Step}
          scrollToFirstStep
          hideBackButton
          stepIndex={stepIndex}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          callback={handleJoyrideCallback}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}

      {isQuizPage && tutorialPhase === 2 && (
        <Joyride
          steps={phase2Step}
          hideBackButton
          stepIndex={stepIndex}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          callback={handleJoyrideCallback}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}

      {isStudyPage &&
        tutorialPhase === 3 &&
        user?.membership > 2 &&
        document.getElementsByClassName("most-difficult-terms-title").length >
          0 && (
          <Joyride
            steps={phase3Step}
            scrollToFirstStep
            hideBackButton
            stepIndex={stepIndex}
            locale={{
              next: "Continue",
              close: "Continue",
              last: "Continue",
            }}
            callback={handleJoyrideCallback}
            //showProgress
            continuous
            hideCloseButton
            styles={{
              options: {
                backgroundColor: "#ffffff",
                textColor: "#747474",
                primaryColor: "#8358E8",
                fontFamily: "Plus Jakarta Sans",
              },
            }}
          ></Joyride>
        )}

      {tutorialPhase === 4 && isDashboardPage && user?.membership > 2 && (
        <Joyride
          steps={phase4Step}
          scrollToFirstStep
          hideBackButton
          stepIndex={stepIndex}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          callback={handleJoyrideCallback}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
    </>
  );
}

export default QuizzyPlusTutorial;
